<script>
export default {
  name: 'FormComponentBase',
  data () {
  },
  props: {
    value: {
      required: true
    },
    metadata: {
      type: Object,
      required: true
    },
    dbfield: {
      type: String,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    input_type () {
      switch (this.metadata.type) {
        case 'choice':
          return 'select'
        case 'datetime':
          return 'datetime-local'
        case 'date':
          return 'date'
        case 'decimal':
          return 'number'
        case 'integer':
          return 'number'
        default:
          return 'text'
      }
    }
  },
  methods: {
    updatex (a) {
      this.$emit('updatex', a)
    }
  }
}
</script>
